export const WhiteBigCircle = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.5" stroke="#ADADAD" />
  </svg>
);

export const PinkBigCircle = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="12" fill="#D65C74"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5755 16C10.3915 16 10.2155 15.924 10.0895 15.79L6.84749 12.3373C6.59482 12.0693 6.60882 11.6473 6.87682 11.3953C7.14549 11.1433 7.56749 11.1567 7.81882 11.4247L10.5688 14.352L16.1742 8.21734C16.4235 7.94467 16.8448 7.92667 17.1168 8.17467C17.3882 8.42267 17.4068 8.84467 17.1588 9.11601L11.0675 15.7827C10.9428 15.92 10.7655 15.9987 10.5802 16H10.5755Z" fill="white"/>
  </svg>
);
